<template>
    <div>
        <el-input class="input userAccount" v-model="user.userAccount" maxlength="40" placeholder="请输入原邮箱"></el-input>
        <div class="verifyCode">
            <el-input class="input" maxlength="6" v-model="user.verifyCode" placeholder="请输入验证码"></el-input>
            <div
                    @click="verify?send_sma():''"
                    :class="['butn',verify?'':'on']"
            >{{verify?'发送验证码':'已发送('+time+')'}}</div>
        </div>
        <el-input class="input userAccount" v-model="user.userAccount" maxlength="40" placeholder="请输入新邮箱"></el-input>
        <div class="verifyCode">
            <el-input class="input" maxlength="6" v-model="user.verifyCode" placeholder="请输入验证码"></el-input>
            <div
                    @click="verify?send_sma():''"
                    :class="['butn',verify?'':'on']"
            >{{verify?'发送验证码':'已发送('+time+')'}}</div>
        </div>
        <div class="account-butn" @click="Confirm_changes()">确认更改</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                user: {
                    userAccount: ""
                },
                dsafety: 0,
                affirm: 0,
                verify:true,
                time:60
            };
        },
        methods: {
            send_sma() {
                if (this.type == 1) {
                    this.$SIF.sendByEmails({
                        params: {
                            templateId: 1,
                            toEmail: this.user.userAccount
                        },
                        succFun: res => {
                            this.verify_num();
                        }
                    });
                } else {
                    this.$SIF.sendByPhone({
                        params: {
                            useWhere: 19,
                            toPhone: this.user.userAccount
                        },
                        succFun: res => {
                            this.verify_num();
                        }
                    });
                }
            },
            verify_num() {
                var time = this.time;
                var that = this;
                var interval = setInterval(function() {
                    if (time <= 1) {
                        clearTimeout(interval);
                        that.verify = true;
                        that.time = 60;
                    } else {
                        time--;
                        that.verify = false;
                        that.time = time;
                    }
                }, 1000);
                this.verify = true;
            },
            Confirm_changes(){
                this.$SIF.httpPost({
                    url: this.$SIF._serve.usermanage + "/user/forgetPassWord",
                    data: {
                        ...this.user,
                        newUserPassword:this.new_password
                    },
                    succFun: res => {
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    },failFun:res=>{
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            }
        }
    };
</script>
<style scoped type="text/css">

    .hint {
        color: #ff1111;
        font-size: 12px;
        margin-top: 10px;
        line-height: 14px;
    }

</style>
<style>

</style>